import { Dispatch } from 'react'
import { CountyActions } from '../../../../../store/County'
import { WellWaterSystemsAggregatesActions,WellWaterSystemCoordinatesActions, WellWaterSystemsMetricsActions, WaterSystemGeoBlocksActions, ZoomLevel } from '../../../../../store/wellWaterSystem'
import { getStateCountiesPolygon } from '../../../../../utils/mapHelper'
import { AmericanStatesActions } from '../../../../../store/AmericanStates'

export const fetchWellAggregatedWaterSystems = async (
  dispatch: Dispatch<any>,
  zoomLevel: ZoomLevel,
  stateCode?: string,
  stateName?: string,
): Promise<void> => {
  try {
    await dispatch(
      WellWaterSystemsAggregatesActions.fetchAggregatedWellWaterSystemsAsync({
        zoomLevel,
        stateCode,
        stateName,
      }) as any,
    )
  } catch (error) {}
}

export const getStateFromZoom = async (
  dispatch,
  mapRef,
  code,
  prevSelectedCode,
  prevSelectedCounty,
  prevSelectedGeoblock,
  fetchWellAggregatedWaterSystems,
  stateName,
) => {
  dispatch(WellWaterSystemsAggregatesActions.setZoomLevel(ZoomLevel.COUNTY))
  const countiesGeo = await getStateCountiesPolygon(code)

  if (countiesGeo) {
    mapRef.current.getSource('maine').setData(countiesGeo)
  }

  const options = {
    params: {
      state_abbr: code,
    },
  }

  dispatch(AmericanStatesActions.setSelectedState({state:stateName}))
  dispatch(WellWaterSystemsMetricsActions.fetchWellWaterSystemMetricsAsync({ options }) as any)

  prevSelectedCode.current = code
  prevSelectedCounty.current = null
  prevSelectedGeoblock.current = null
  await fetchWellAggregatedWaterSystems(dispatch, ZoomLevel.COUNTY, code, stateName)
}

export const getCoordinatesFromGeoBlock = (
  dispatch,
  geoblockId,
  prevSelectedGeoblock,
) => {
   prevSelectedGeoblock.current = geoblockId
   const blockGroupGeoid = geoblockId?.substring(0, 12);
   dispatch(WaterSystemGeoBlocksActions.setSelectedGeoBlock(blockGroupGeoid))
    dispatch(WellWaterSystemCoordinatesActions.createWellWaterSystemCoordinatesAsync([blockGroupGeoid]) as any)
   
    const options = {
      params: {
        geoblk_grp: blockGroupGeoid,
      },
    }

    dispatch(WellWaterSystemsMetricsActions.fetchWellWaterSystemMetricsAsync({ options }) as any)
}

export const getGeoBlocksFromCounty = async (
  dispatch,
  countyHousingUnitsRef,
  countyName,
  prevSelectedCounty,
  prevSelectedCode,
  prevSelectedGeoblock,
) => {
  const countyHousingUnitsData = countyHousingUnitsRef?.current
  const county = countyHousingUnitsData?.find(
    (item) => item?.county_name?.trim()?.toLowerCase() === countyName?.trim()?.toLowerCase(),
  )

  if (county?.geoblockIds) {
    prevSelectedCounty.current = countyName
    prevSelectedCode.current = null
    prevSelectedGeoblock.current = null
    dispatch(CountyActions.setSelectedCounty(countyName))
    dispatch(WaterSystemGeoBlocksActions.createWaterSystemGeoBlocksAsync(county.geoblockIds) as any)
    const options = {
      params: {
        county_name: countyName,
      },
    }

    dispatch(WellWaterSystemsMetricsActions.fetchWellWaterSystemMetricsAsync({ options }) as any)
  }
}
